import ObjArrUtils from '@/utils/ObjArrUtils'
import ApiUtils from '@/utils/api/ApiUtils'
import { Base } from '@/store/base/module'

const module = {
  state: {
    supportList: [],

    // Edit page state
    currentSupport: null,
    isLoading: false,
    isSaving: false,

    // Form state
    editForm: {
      support_no: null,
      title: '',
      content: '',
      file_json: '[]',
      remarks: '',
      lock_version: 0
    },

    // Preview state
    isPreviewMode: false
  },

  getters: {
  },

  mutations: {},

  actions: {
    // Browse support entries - following M20901 pattern
    async doBrowse({ commit, state }) {
      commit('setState', { isLoading: true })

      try {
        const res = await ApiUtils.postData({
          data: {
            browse: {
              api: 'M0050SupportService.M21101_doBrowse',
              input: {}
            }
          }
        })

        commit('setState', {
          supportList: res.browse.output,
          isLoading: false
        })

        return { success: true }
      } catch (error) {
        commit('setState', { isLoading: false })
        throw error
      }
    },

    // Get support detail for editing - following M20901 pattern
    async getDetail({ commit, state, getters }, supportNo) {
      commit('setState', { isLoading: true })

      try {
        const res = await ApiUtils.postData({
          data: {
            getDetail: {
              api: 'M0050SupportService.M21101_getEdit',
              input: { support_no: supportNo }
            }
          }
        })

        const result = res.getDetail.output
        commit('setState', {
          currentSupport: result,
          editForm: {
            support_no: result.support_no,
            title: result.title,
            content: result.content,
            file_json: result.file_json,
            remarks: result.remarks,
            lock_version: result.lock_version || 0
          },
          isLoading: false
        })

        return { success: true, data: result }
      } catch (error) {
        console.warn('API call failed, using mock data:', error)

        commit('setState', { isLoading: false })
        throw error
      }
    },

    // Save support entry - following M20901 pattern
    async doEdit({ commit, state }) {
      commit('setState', { isSaving: true })

      try {
        // Client-side validation
        if (!state.editForm.content?.trim()) {
          window.vue.$dialog.notify.error('コンテンツは必須です')
          commit('setState', { isSaving: false })
          return { success: false }
        }

        const res = await ApiUtils.postData({
          data: {
            doEdit: {
              api: 'M0050SupportService.M21101_doEdit',
              input: {
                support_no: state.editForm.support_no,
                title: state.editForm.title,
                content: state.editForm.content,
                file_json: state.editForm.file_json,
                remarks: state.editForm.remarks,
                lock_version: state.editForm.lock_version
              }
            }
          }
        })

        const result = res.doEdit.output
        commit('setState', {
          currentSupport: result,
          editForm: {
            ...state.editForm,
            lock_version: result.lock_version
          },
          isSaving: false
        })

        return { success: true, message: '保存しました' }
      } catch (error) {
        commit('setState', { isSaving: false })
        throw error
      }
    },

    // Reset form action - using setState instead of custom mutation
    resetForm({ commit }) {
      commit('setState', {
        editForm: {
          support_no: null,
          title: '',
          content: '',
          file_json: '[]',
          remarks: '',
          lock_version: 0
        },
        errors: {},
        currentSupport: null
      })
    },

    // Update form field action - using setState instead of custom mutation
    updateField({ commit, state }, { field, value }) {
      commit('setState', {
        editForm: {
          ...state.editForm,
          [field]: value
        },
        errors: {
          ...state.errors,
          [field]: undefined // Clear error for this field
        }
      })
    }
  }
}

export default ObjArrUtils.merge(Base, module)
